export default class SimpleService {
  public id!: number
  public name!: string
}
